import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { BaseAuthComponent } from '@layouts/default/layouts/guest/pages/home/components/base-auth.component';
import { AccountService } from '@layouts/default/layouts/logged/pages/account/account.service';
import { PhDropComponent } from '@shared/components/ph-drop/ph-drop.component';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { HeaderService } from '@shared/services/header.service';
import { MenuService } from '@shared/services/menu.service';
import { ItemMenu } from '@shared/models/item-menu.model';
import { Menu } from '@shared/interfaces/menu/menu.interface';
import { MenuType } from '@shared/interfaces/menu/menuType.interface';
import { RoutesPath } from '@shared/routes-path';
import { isMcdDashboardAccessOverrideEnabled } from '@shared/mcd-access';
import { logMcdDiagnosticsOnce } from '@shared/mcd-diagnostics';

@Component({
  selector: 'app-header-desktop',
  templateUrl: './header-desktop.component.html',
  styleUrls: ['./header-desktop.component.scss'],
})
export class HeaderDesktopComponent extends BaseAuthComponent implements Menu {
  cartListLength: number = 0;
  ukraineUrl: boolean = false;
  instagramLink: string;
  facebookLink: string;
  headerLink: string = RoutesPath.default.home;
  logoSrc: string = 'assets/img/logo.svg';

  @Input() eventCategory;
  @Input() notificationsUnseen: number = null;
  @Output() inputFocusEmitter: EventEmitter<any> = new EventEmitter();
  @Output() getStatistictEmitter: EventEmitter<any> = new EventEmitter();
  @Output() cartListLengthEmitter: EventEmitter<any> = new EventEmitter();
  @ViewChild('dropNotification') dropNotification: PhDropComponent;
  @Input() menuItems: ItemMenu[];

  constructor(
    public accountService: AccountService,
    public route: ActivatedRoute,
    public router: Router,
    public header: HeaderService,
    public menuService: MenuService
  ) {
    super();

    router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.refreshHeaderMenu();
      }
    });
    const groupsSub = this.storage.userGroupsState$.subscribe((state) => {
      if (state.status !== 'refreshing') {
        this.refreshHeaderMenu();
      }
    });
    this.someSubscriptions.add(groupsSub);
  }

  private refreshHeaderMenu() {
    this.menuItems = this.menuService.loadMenu();
    this.facebookLink = this.menuService.facebookLink();
    this.instagramLink = this.menuService.instagramLink();
    this.ukraineUrl = this.menuService.isUkraineUrl();
    this.headerLink = this.menuService.getHeaderLink();
    this.logoSrc = this.menuService.getLogo();
    this.logMcdHeaderDiagnostics();
  }

  private logMcdHeaderDiagnostics() {
    const user = this.storage.user;
    const isMcdEmployee = this.storage.isMcdEmployee;
    const menuType = this.menuService.geType();
    const menuItems = this.menuItems ?? [];
    const viewportWidth = typeof window !== 'undefined' ? window.innerWidth : null;
    const activeHeaderVariant =
      viewportWidth === null ? 'unknown' : viewportWidth > 885 ? 'desktop' : 'mobile';
    const ukrainianRouteMatches = ['helpukraine', 'how-to-help-ukraine', 'help-ukraine'].filter(
      (route) => this.menuService.isActive(route)
    );
    const headerEventCategory = this.header.eventCategory;
    const storageIsAuthFromUkraine = this.storage.isAuthFromUkraine;
    const reportActionButtonVisible = !this.ukraineUrl && isMcdEmployee;

    logMcdDiagnosticsOnce(
      'header-desktop',
      `${this.router.url}|${!!user}|${isMcdEmployee}|${this.ukraineUrl}|${menuType}|${
        viewportWidth ?? 'no-window'
      }`,
      {
        headerComponent: 'desktop',
        url: this.router.url,
        viewportWidth,
        activeHeaderVariant,
        hasUser: !!user,
        isMcdEmployee,
        overrideEnabled: isMcdDashboardAccessOverrideEnabled(),
        ukraineUrl: this.ukraineUrl,
        ukrainianRouteMatches,
        headerEventCategory,
        storageIsAuthFromUkraine,
        menuType,
        menuTypeName: MenuType[menuType],
        menuItems: menuItems.map((item) => item.routerLink ?? item.outgoingLink),
        reportActionButtonVisible,
        reportActionButtonVisibleInActiveHeader:
          activeHeaderVariant === 'desktop' && reportActionButtonVisible,
        dashboardDropdownItemVisible: isMcdEmployee,
        standardCreateButtonsVisible: !this.ukraineUrl && !isMcdEmployee,
      }
    );
  }

  isColored(pages: Array<string>) {
    const isWelcomePage = this.router.url === '/';
    const filtered = pages.filter((page) => this.router.url.search(page) > 0);
    return isWelcomePage || filtered.length > 0;
  }

  onCloseNotifications() {
    this.getStatistictEmitter.emit();
    this.dropNotification.close();
  }

  updateCartListLabel(length) {
    this.cartListLength = length;
    this.cartListLengthEmitter.emit(length);
  }

  setAutoFocus(value) {
    this.storage.put('autofocus', value);
  }

  removeAutofocus() {
    this.storage.delete('autofocus');
  }

  isActive(page: string) {
    return this.menuService.isActive(page);
  }

  onAvatarClick() {
    if (this.storage.isMcdEmployee) {
      this.router.navigate(['/' + this.RoutesPath.default.mcd_dashboard]);
      return;
    }
    this.router.navigate([
      '/' +
        this.RoutesPath.default.profile +
        '/' +
        this.storage.user.id +
        '/' +
        this.RoutesPath.default.profileTabs.summary,
    ]);
  }
}
